/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface VersionItem
 */
export interface VersionItem {
  /**
   *
   * @type {string}
   * @memberof VersionItem
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof VersionItem
   */
  version: string;
}

/**
 * Check if a given object implements the VersionItem interface.
 */
export function instanceOfVersionItem(value: object): value is VersionItem {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('version' in value) || value['version'] === undefined) return false;
  return true;
}

export function VersionItemFromJSON(json: any): VersionItem {
  return VersionItemFromJSONTyped(json, false);
}

export function VersionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionItem {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    version: json['version']
  };
}

export function VersionItemToJSON(value?: VersionItem | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    version: value['version']
  };
}
